import { memo } from "react";
import PropTypes from "prop-types";
import MediaThumbnailItem from "../../../features/media/components/MediaThumbnail";
import { galleryShell } from "../../../styles/galleryShell";

function GalleryGrid({ items, onItemClick, emptyMessage = "メディアがありません" }) {
    if (!items || items.length === 0) {
        return (
            <div className={galleryShell.gridEmpty}>
                <p>{emptyMessage}</p>
            </div>
        );
    }

    return (
        <div className={galleryShell.grid}>
            {items.map(({ media, location }) => (
                <MediaThumbnailItem
                    key={`${media.id}-${location.id}`}
                    item={media}
                    userName={location.user}
                    onClick={() => onItemClick({ media, location })}
                />
            ))}
        </div>
    );
}

GalleryGrid.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            media: PropTypes.object.isRequired,
            location: PropTypes.object.isRequired
        })
    ).isRequired,
    onItemClick: PropTypes.func.isRequired,
    emptyMessage: PropTypes.string
};

// React.memoでメモ化し、propsが変更された場合のみ再レンダリング
export default memo(GalleryGrid);
